import getHeaderH from './getHeaderH';
import scrollTo from './scrollTo';

/**
 * スムーススクロール
 * @param {boolean} headerisFixed - ヘッダーが追従するかどうか（移動位置の計算に使用）
 */
const smoothScroll = (headerisFixed = true) => {
    const doWhenLoaded = () => {
        // すべてのアンカーリンクのaタグを取得（#を含むもの）
        const triggerList = document.querySelectorAll('a[href*="#"]');
        if (!triggerList.length) return;

        for (let i = 0; i < triggerList.length; i++) {
            const trigger = triggerList[i];

            // 重複バインド防止
            if (trigger.dataset.smoothBound === '1') continue;
            trigger.dataset.smoothBound = '1';

            // aタグにそれぞれクリックイベントを設定
            trigger.addEventListener('click', (e) => {
                const href = trigger.getAttribute('href') || '';

                // ハッシュが無い/空は対象外
                if (!href.includes('#')) return;

                // 同一ページ内のアンカーでのみスムーススクロール実行
                // hrefが"#..."（相対ハッシュのみ）の場合は同一ページ扱い
                // もしくはフル/ルートURLでも現在と同じパスでハッシュがある場合のみ
                let isSamePageHash = false;
                try {
                    if (href.startsWith('#')) {
                        isSamePageHash = true;
                    } else {
                        const url = new URL(href, window.location.href);
                        isSamePageHash = (
                            url.origin === window.location.origin &&
                            url.pathname === window.location.pathname &&
                            !!url.hash
                        );
                    }
                } catch (_) {
                    // 万一URLパースに失敗した場合は処理しない（通常遷移）
                    isSamePageHash = false;
                }

                if (!isSamePageHash) return; // 別ページへのリンクは通常遷移

                e.preventDefault();

                const hash = href.split('#')[1];
                const target = hash ? document.getElementById(hash) : null;
                let pos = 0; // 初期値0(ターゲットが存在しない場合はTOPに移動)

                if (target) {
                    const headerH = headerisFixed ? getHeaderH() : 0; // クリック時点のヘッダー高さを取得
                    const offset = target.getBoundingClientRect().top; // ブラウザからの高さを取得
                    pos = offset + window.scrollY - headerH; // 最終的な位置
                }

                // スクロールを実行
                scrollTo(pos);
            });
        }
    }
    // 初回のみ設定（リサイズ時の再バインドは不要）
    window.addEventListener('load', doWhenLoaded);
}

export default smoothScroll